import React from 'react';
import { Link } from 'react-router-dom';
import WidAbout from './WidAbout';
import WidGetTouch from './WidGetTouch';
import WidPages from './WidPages';

function Footer2() {
    return (
        <footer className="footer-2 footer-wrap">
            <div className="footer-widgets">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 col-xl-4 col-12">
                            <WidAbout />
                        </div>
                        <div className="col-md-3 col-xl-2 col-12">
                            <WidPages />
                        </div>
                        <div className="col-md-5 col-xl-6 col-12 pl-xl-4">
                            <WidGetTouch />
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom text-white">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12 col-12 text-center text-lg-left">
                            <div className="copyright-info">
                                <p>
                                    Powered By <Link to="https://asitech.id">Aksara Systems</Link>{' '}
                                    - 2026<br />&copy; CV. Kalimantan Jaya Diesel. All Rights Reserved.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer2;
